import { SyntheticEvent, useState } from 'react';

type DropdownData = {
  label: string;
  value: string;
};

type UseViewModelProps = {
  value: string;
  onChange: (value: string) => void;
  data: DropdownData[];
};

type UseViewModelReturn = {
  anchorEl: HTMLButtonElement | null;
  selectedLabel: string;
  handleMenuClick: (event: SyntheticEvent<HTMLButtonElement>) => void;
  handleItemSelect: (item: DropdownData) => void;
  handleClose: () => void;
};

const useViewModel = ({
  value,
  onChange,
  data,
}: UseViewModelProps): UseViewModelReturn => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [selectedLabel, setSelectedLabel] = useState<string>(
    value === ''
      ? data[0]?.label
      : data.find((item) => item.value === value)?.label || ''
  );

  const handleItemSelect = (item: DropdownData): void => {
    setSelectedLabel(item.label);
    onChange(item.value);
    setAnchorEl(null);
  };

  const handleMenuClick = (event: SyntheticEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return {
    anchorEl,
    selectedLabel,
    handleMenuClick,
    handleItemSelect,
    handleClose,
  };
};

export default useViewModel;
